import consumptionDataFromJson from "../consumption/mapper";
import emissionsDataFromJson from "../emissions/mapper";
import expensesDataFromJson from "../expenses/mapper";
import savingsDataFromJson from "../savings/mapper";
import RouteFeatureData from "./data";

export default function routeFeatureDataFromJson(json) {
  return new RouteFeatureData(
    emissionsDataFromJson(json.cO2),
    consumptionDataFromJson(json.consumption),
    expensesDataFromJson(json.expenses),
    savingsDataFromJson(json.savings),
    json.distance,
    json.fuelLowSulfur,
    json.fuelOil,
    json.tce,
    json.time
  );
}
